var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 89,
    viewBox: "0 0 237 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google Play Black"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Body",
    width: 236.433,
    height: 88.1219,
    rx: 13.3014,
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    filter: "url(#filter0_ii_56_21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.5977 22.3142C23.0868 22.857 22.7849 23.6995 22.7849 24.7904V63.7685C22.7849 64.8612 23.0868 65.7019 23.5977 66.2448L23.7276 66.3716L45.4776 44.5368V44.2795V44.0222L23.7276 22.1855L23.5977 22.3142Z",
    fill: "url(#paint0_linear_56_21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.726 51.8173L45.4771 44.5367V44.2794V44.022L52.7277 36.7432L52.891 36.8366L61.4811 41.7362C63.9336 43.1355 63.9336 45.4249 61.4811 46.8261L52.891 51.7257L52.726 51.8173Z",
    fill: "url(#paint1_linear_56_21)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter1_i_56_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8914 51.7236L45.4758 44.2791L23.5977 66.2443C24.4053 67.1044 25.7413 67.2101 27.2458 66.3536L52.8914 51.7236Z",
    fill: "url(#paint2_linear_56_21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.8914 36.8351L27.2458 22.2068C25.7413 21.3485 24.4053 21.456 23.5977 22.3161L45.4776 44.2814L52.8914 36.8351Z",
    fill: "url(#paint3_linear_56_21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Google Play",
    d: "M118.485 46.4119C114.585 46.4119 111.406 49.3768 111.406 53.4602C111.406 57.5189 114.585 60.5085 118.485 60.5085C122.386 60.5085 125.565 57.5189 125.565 53.4602C125.563 49.3768 122.384 46.4119 118.485 46.4119ZM118.485 57.7343C116.347 57.7343 114.505 55.9726 114.505 53.4619C114.505 50.9246 116.349 49.1895 118.485 49.1895C120.622 49.1895 122.464 50.9246 122.464 53.4619C122.464 55.971 120.622 57.7343 118.485 57.7343ZM103.041 46.4119C99.1412 46.4119 95.9627 49.3768 95.9627 53.4602C95.9627 57.5189 99.1412 60.5085 103.041 60.5085C106.943 60.5085 110.121 57.5189 110.121 53.4602C110.121 49.3768 106.943 46.4119 103.041 46.4119ZM103.041 57.7343C100.904 57.7343 99.0617 55.9726 99.0617 53.4619C99.0617 50.9246 100.905 49.1895 103.041 49.1895C105.178 49.1895 107.021 50.9246 107.021 53.4619C107.022 55.971 105.178 57.7343 103.041 57.7343ZM84.6727 48.5763V51.566H91.8324C91.6185 53.2481 91.058 54.4761 90.2025 55.3296C89.1612 56.3704 87.5313 57.5189 84.6727 57.5189C80.2655 57.5189 76.82 53.9674 76.82 49.5624C76.82 45.1574 80.2655 41.6059 84.6727 41.6059C87.0504 41.6059 88.7865 42.5406 90.0682 43.7421L92.1789 41.6324C90.3882 39.9238 88.0121 38.6162 84.6727 38.6162C78.6356 38.6162 73.5602 43.5283 73.5602 49.5624C73.5602 55.5964 78.6356 60.5085 84.6727 60.5085C87.9309 60.5085 90.3898 59.4396 92.3116 57.4376C94.288 55.4622 94.9032 52.6846 94.9032 50.4424C94.9032 49.7496 94.8501 49.1083 94.7423 48.5747L84.6727 48.5763ZM159.798 50.8981C159.211 49.3237 157.42 46.4119 153.761 46.4119C150.128 46.4119 147.108 49.269 147.108 53.4602C147.108 57.4111 150.101 60.5085 154.107 60.5085C157.339 60.5085 159.209 58.5331 159.985 57.3846L157.581 55.782C156.78 56.957 155.684 57.731 154.107 57.731C152.532 57.731 151.409 57.0101 150.688 55.5948L160.118 51.6969L159.798 50.8981ZM150.181 53.2481C150.101 50.5236 152.291 49.1365 153.868 49.1365C155.097 49.1365 156.138 49.7513 156.486 50.6313L150.181 53.2481ZM142.515 60.0826H145.613V39.3653H142.515V60.0826ZM137.438 47.988H137.332C136.637 47.1594 135.301 46.4119 133.62 46.4119C130.093 46.4119 126.861 49.5093 126.861 53.4884C126.861 57.4393 130.093 60.5102 133.62 60.5102C135.303 60.5102 136.637 59.7628 137.332 58.9093H137.438V59.9235C137.438 62.6199 135.996 64.0617 133.673 64.0617C131.776 64.0617 130.6 62.7011 130.119 61.5526L127.422 62.6746C128.196 64.5423 130.252 66.8393 133.673 66.8393C137.306 66.8393 140.378 64.7031 140.378 59.496V46.8412H137.44L137.438 47.988ZM133.887 57.7343C131.749 57.7343 129.96 55.9445 129.96 53.4884C129.96 51.0042 131.749 49.1895 133.887 49.1895C135.996 49.1895 137.652 51.0042 137.652 53.4884C137.652 55.9445 135.996 57.7343 133.887 57.7343ZM174.313 39.3653H166.899V60.0826H169.992V52.2339H174.311C177.74 52.2339 181.112 49.753 181.112 45.8004C181.112 41.8479 177.742 39.3653 174.313 39.3653ZM174.392 49.3502H169.992V42.2489H174.392C176.705 42.2489 178.018 44.163 178.018 45.8004C178.018 47.4046 176.705 49.3502 174.392 49.3502ZM193.513 46.3755C191.273 46.3755 188.954 47.3615 187.993 49.5475L190.739 50.6926C191.326 49.5475 192.421 49.1729 193.566 49.1729C195.166 49.1729 196.793 50.1325 196.82 51.8378V52.0516C196.259 51.7317 195.059 51.2528 193.593 51.2528C190.633 51.2528 187.619 52.8785 187.619 55.9163C187.619 58.6889 190.046 60.4737 192.765 60.4737C194.845 60.4737 195.992 59.5407 196.712 58.4469H196.818V60.0462H199.806V52.1029C199.807 48.4272 197.058 46.3755 193.513 46.3755ZM193.139 57.7293C192.127 57.7293 190.713 57.2222 190.713 55.9693C190.713 54.3701 192.474 53.7569 193.994 53.7569C195.352 53.7569 195.994 54.0502 196.82 54.4496C196.579 56.3704 194.926 57.7293 193.139 57.7293ZM210.686 46.8279L207.14 55.8102H207.033L203.352 46.8279H200.02L205.539 59.3816L202.392 66.3653H205.619L214.127 46.8279H210.686ZM182.82 60.0826H185.913V39.3653H182.82V60.0826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Get it on"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2866 27.111C84.2866 28.4746 83.8757 29.5599 83.0524 30.3703C82.1181 31.3336 80.8988 31.8153 79.4012 31.8153C77.9666 31.8153 76.7457 31.3271 75.7434 30.3508C74.7395 29.3728 74.2376 28.1621 74.2376 26.7172C74.2376 25.2706 74.7395 24.0599 75.7434 23.0836C76.7457 22.1056 77.9666 21.6174 79.4012 21.6174C80.1136 21.6174 80.7944 21.7541 81.4405 22.0259C82.0882 22.2992 82.6068 22.6621 82.9944 23.1161L82.1214 23.9753C81.4637 23.2024 80.5575 22.8167 79.3996 22.8167C78.3526 22.8167 77.4481 23.1779 76.6844 23.9004C75.9207 24.6229 75.5397 25.5618 75.5397 26.7155C75.5397 27.8692 75.9207 28.8082 76.6844 29.5306C77.4481 30.2531 78.3526 30.6144 79.3996 30.6144C80.5095 30.6144 81.4355 30.2515 82.176 29.5241C82.6565 29.0506 82.9348 28.3916 83.0093 27.5471H79.3996V26.3738H84.2153C84.265 26.6293 84.2866 26.875 84.2866 27.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9237 23.0332H87.3978V26.1282H91.4797V27.3014H87.3978V30.3964H91.9237V31.5973H86.1206V21.8339H91.9237V23.0332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3091 31.5973H96.0319V23.0332H93.2554V21.8339H100.086V23.0332H97.3091V31.5973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.027 31.5973V21.8339H106.304V31.5973H105.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.969 31.5973H110.691V23.0332H107.915V21.8339H114.745V23.0332H111.969V31.5973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.675 30.3362C126.697 31.3223 125.483 31.8154 124.03 31.8154C122.577 31.8154 121.363 31.3223 120.387 30.3362C119.41 29.3501 118.923 28.1427 118.923 26.7156C118.923 25.2885 119.41 24.0811 120.387 23.095C121.363 22.1089 122.577 21.6143 124.03 21.6143C125.475 21.6143 126.687 22.1106 127.668 23.1015C128.649 24.0925 129.139 25.2967 129.139 26.7156C129.139 28.1427 128.65 29.3501 127.675 30.3362ZM121.33 29.5177C122.065 30.25 122.965 30.6145 124.03 30.6145C125.095 30.6145 125.996 30.2483 126.73 29.5177C127.466 28.7855 127.835 27.8514 127.835 26.7156C127.835 25.5798 127.466 24.6458 126.73 23.9135C125.996 23.1813 125.095 22.8168 124.03 22.8168C122.965 22.8168 122.065 23.1829 121.33 23.9135C120.596 24.6458 120.226 25.5798 120.226 26.7156C120.226 27.8514 120.596 28.7855 121.33 29.5177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.932 31.5973V21.8339H132.485L137.316 29.4282H137.371L137.316 27.5471V21.8339H138.593V31.5973H137.26L132.205 23.6337H132.151L132.205 25.5147V31.5973H130.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2866 27.111C84.2866 28.4746 83.8757 29.5599 83.0524 30.3703C82.1181 31.3336 80.8988 31.8153 79.4012 31.8153C77.9666 31.8153 76.7457 31.3271 75.7434 30.3508C74.7395 29.3728 74.2376 28.1621 74.2376 26.7172C74.2376 25.2706 74.7395 24.0599 75.7434 23.0836C76.7457 22.1056 77.9666 21.6174 79.4012 21.6174C80.1136 21.6174 80.7944 21.7541 81.4405 22.0259C82.0882 22.2992 82.6068 22.6621 82.9944 23.1161L82.1214 23.9753C81.4637 23.2024 80.5575 22.8167 79.3996 22.8167C78.3526 22.8167 77.4481 23.1779 76.6844 23.9004C75.9207 24.6229 75.5397 25.5618 75.5397 26.7155C75.5397 27.8692 75.9207 28.8082 76.6844 29.5306C77.4481 30.2531 78.3526 30.6144 79.3996 30.6144C80.5095 30.6144 81.4355 30.2515 82.176 29.5241C82.6565 29.0506 82.9348 28.3916 83.0093 27.5471H79.3996V26.3738H84.2153C84.265 26.6293 84.2866 26.875 84.2866 27.111Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9237 23.0332H87.3978V26.1282H91.4797V27.3014H87.3978V30.3964H91.9237V31.5973H86.1206V21.8339H91.9237V23.0332Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3091 31.5973H96.0319V23.0332H93.2554V21.8339H100.086V23.0332H97.3091V31.5973Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.027 31.5973V21.8339H106.304V31.5973H105.027Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.969 31.5973H110.691V23.0332H107.915V21.8339H114.745V23.0332H111.969V31.5973Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.675 30.3362C126.697 31.3223 125.483 31.8154 124.03 31.8154C122.577 31.8154 121.363 31.3223 120.387 30.3362C119.41 29.3501 118.923 28.1427 118.923 26.7156C118.923 25.2885 119.41 24.0811 120.387 23.095C121.363 22.1089 122.577 21.6143 124.03 21.6143C125.475 21.6143 126.687 22.1106 127.668 23.1015C128.649 24.0925 129.139 25.2967 129.139 26.7156C129.139 28.1427 128.65 29.3501 127.675 30.3362ZM121.33 29.5177C122.065 30.25 122.965 30.6145 124.03 30.6145C125.095 30.6145 125.996 30.2483 126.73 29.5177C127.466 28.7855 127.835 27.8514 127.835 26.7156C127.835 25.5798 127.466 24.6458 126.73 23.9135C125.996 23.1813 125.095 22.8168 124.03 22.8168C122.965 22.8168 122.065 23.1829 121.33 23.9135C120.596 24.6458 120.226 25.5798 120.226 26.7156C120.226 27.8514 120.596 28.7855 121.33 29.5177Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.932 31.5973V21.8339H132.485L137.316 29.4282H137.371L137.316 27.5471V21.8339H138.593V31.5973H137.26L132.205 23.6337H132.151L132.205 25.5147V31.5973H130.932Z",
    stroke: "white",
    strokeWidth: 0.0680073,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_56_21",
    x: 22.7849,
    y: 21.6145,
    width: 40.5356,
    height: 45.3308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.264366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_56_21"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.264366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_56_21",
    result: "effect2_innerShadow_56_21"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_56_21",
    x: 23.5977,
    y: 44.2791,
    width: 29.2937,
    height: 22.6663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.264366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_56_21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_21",
    x1: 43.5496,
    y1: 24.378,
    x2: 13.9726,
    y2: 53.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56_21",
    x1: 64.6736,
    y1: 44.2794,
    x2: 22.1956,
    y2: 44.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56_21",
    x1: 48.8643,
    y1: 48.3219,
    x2: 8.75411,
    y2: 88.2761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_56_21",
    x1: 18.0876,
    y1: 9.34066,
    x2: 35.9979,
    y2: 27.1813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.3795e469cf85f6f9b4173cd43150d714.svg";
export { ForwardRef as ReactComponent };